/**
 * Loads html of table containing search results as promise.
 */
export function loadSearchTableHtmlAsPromise(searchQuery: string, domain: string): Promise<any> {

    const fetchUrl = '/share/ajax/kamery_vyhledavac2.php';

    const fetchOptions = {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify( {
            // 'pattern' is searched query and 'domain' is needed variable.
            pattern: searchQuery,
            domain: domain
        } ),
    };

    return fetch(fetchUrl, fetchOptions as RequestInit);
}